import Users from '../components/Users'
import './UsersIndex.css'
function UsersIndex() {
  return (
    <div className='Index'>
      <h1 className='title'>
        Meet Our Game Switchers!
      </h1>
      <Users/>
    </div>
  )
}

export default UsersIndex
